(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// In View Class
//
// ------------------------------------

//posts-loop
(function($) {

	if (typeof window.InViewClass == 'undefined') window.InViewClass = {};

	InViewClass = {

		selector: null,

		className: 'in-view',


		// ------------------------------------
		// Init
		// ------------------------------------

	    init: function(selector) {

	    	if(!selector) return;
	    	if($(selector).length < 1) return;

	    	// Save the selector
	    	this.selector = selector;

	    	// Set Up Scroll
	    	this.scroll();

	    	// Set Initial State
	    	InViewClass.look();

	    },

	    // ------------------------------------
	    // Scroll
	    // ------------------------------------

	    scroll: function(){

	    	$(window).scroll(function () {
			    
				InViewClass.look();
				if($(window).scrollTop() > 20){
					$('html').addClass('-scrolling')
				} else {
					$('html').removeClass('-scrolling')
				}

			});

	    },


	    // ------------------------------------
	    // Validate
	    // ------------------------------------

	    look: function(){

	    	$(InViewClass.selector).each(function () {

		    	if (InViewClass.isVisible($(this)) === true) $(this).addClass(InViewClass.className)
		        
		    });

	    },


	    // ------------------------------------
	    // Visible
	    // ------------------------------------

	    isVisible: function($elem) {

		    var docViewTop = $(window).scrollTop();
		    var docViewBottom = docViewTop + $(window).height();


		    var elemTop = $elem.offset().top;
		    var elemBottom = elemTop + $elem.height();

		    return (elemTop <= docViewBottom);

		}

	}

	module.exports = InViewClass;

})(jQuery);
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/in-view-class.js","/modules")